import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import TogglePill from '../TogglePill';
const TogglePillGroup = t0 => {
  const $ = _c(20);
  const {
    className: t1,
    items: t2,
    selectedItem,
    selectedItems: t3,
    bindValues: t4,
    groupName: t5,
    variant
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const items = t6;
  let t7;
  if ($[2] !== t3) {
    t7 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const selectedItems = t7;
  const bindValues = t4 === undefined ? false : t4;
  const groupName = t5 === undefined ? "" : t5;
  const t8 = `flex flex-wrap list-none m-0 ${className}`;
  let t9;
  if ($[4] !== bindValues || $[5] !== groupName || $[6] !== items || $[7] !== selectedItem || $[8] !== selectedItems || $[9] !== variant) {
    let t10;
    if ($[11] !== bindValues || $[12] !== groupName || $[13] !== selectedItem || $[14] !== selectedItems || $[15] !== variant) {
      t10 = t11 => {
        const {
          ariaLabel,
          id,
          label,
          isLoading,
          isSelected,
          isDisabled,
          onClick
        } = t11;
        return <li key={id}><TogglePill aria-label={ariaLabel} isDisabled={isDisabled} key={label} isSelected={isSelected || selectedItem === id || selectedItems.includes(id)} onClick={!isLoading && !isDisabled ? bindValues ? () => onClick(groupName, id) : onClick : null} variant={variant}>{label}</TogglePill></li>;
      };
      $[11] = bindValues;
      $[12] = groupName;
      $[13] = selectedItem;
      $[14] = selectedItems;
      $[15] = variant;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    t9 = items.map(t10);
    $[4] = bindValues;
    $[5] = groupName;
    $[6] = items;
    $[7] = selectedItem;
    $[8] = selectedItems;
    $[9] = variant;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <ul className={t8}>{t9}</ul>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
TogglePillGroup.propTypes = {
  bindValues: PropTypes.bool,
  className: PropTypes.string,
  groupName: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isSelected: PropTypes.bool,
    label: PropTypes.node,
    onClick: PropTypes.func
  })),
  selectedItem: PropTypes.string,
  selectedItems: PropTypes.array,
  variant: PropTypes.oneOf(['ShopByHeaderSection'])
};
export default TogglePillGroup;